export const SNOWPACK_PUBLIC_VERSION = "5.42.3";
export const SNOWPACK_PUBLIC_TARGET = "https://accounts.advai.net";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;